import { QuestionType } from '@/contracts/enums/questionTypes';

export interface QuestionTypeOption {
  label: string;
  value: QuestionType;
  disabled?: boolean;
}

/**
 * Single source of truth for question types in the correct order
 * Community Mixer is last in the list
 */
export const getQuestionTypeOptions = (
  t: (key: string) => string,
  mixerQuestionId?: string,
  currentQuestionId?: string,
  excludeMixer = false
): QuestionTypeOption[] => {
  // Mixer is disabled if another question is already the mixer
  const isMixerDisabled =
    mixerQuestionId != null && mixerQuestionId !== currentQuestionId;

  const options: QuestionTypeOption[] = [
    {
      label: t('editor.questionTypes.text'),
      value: QuestionType.Text,
    },
    {
      label: t('editor.questionTypes.comment'),
      value: QuestionType.Comment,
    },
    {
      label: t('editor.questionTypes.boolean'),
      value: QuestionType.Boolean,
    },
    {
      label: t('editor.questionTypes.radiogroup'),
      value: QuestionType.RadioGroup,
    },
    {
      label: t('editor.questionTypes.checkbox'),
      value: QuestionType.Checkbox,
    },
    {
      label: t('editor.questionTypes.dropdown'),
      value: QuestionType.Dropdown,
    },
    {
      label: t('editor.questionTypes.multiselectdropdown'),
      value: QuestionType.MultiSelectDropdown,
    },
    {
      label: t('editor.questionTypes.rating'),
      value: QuestionType.Rating,
    },
    {
      label: t('editor.questionTypes.matrix'),
      value: QuestionType.Matrix,
    },
    {
      label: t('editor.questionTypes.mixer'),
      value: QuestionType.Mixer,
      disabled: isMixerDisabled,
    },
  ];

  return excludeMixer
    ? options.filter(option => option.value !== QuestionType.Mixer)
    : options;
};

/**
 * Creates menu items for the question type split button
 * @param t - Translation function
 * @param onAddQuestion - Callback to add a question of the specified type
 * @param mixerQuestionId - ID of the existing mixer question (if any)
 * @returns Array of menu items for PrimeReact SplitButton
 */
export const createQuestionMenuItems = (
  t: (key: string) => string,
  onAddQuestion: (type: QuestionType) => void,
  mixerQuestionId?: string
) => {
  const options = getQuestionTypeOptions(t, mixerQuestionId);

  return options.map(option => ({
    label: option.label,
    command: () => onAddQuestion(option.value),
    disabled: option.disabled,
  }));
};
